// extracted by mini-css-extract-plugin
module.exports = {"content":"Message_content__ts4HK"};